function handleSearchWithOperator () {
  $(".filter-with-operator").on("change", "select.operator", function() {
    const operator = $(this).val();
    const input = $(this).closest(".filter-with-operator").find(".search-field");
    input.attr("name", `q[${operator}]`);
  })
}

export { handleSearchWithOperator };
